"use client"
import Script from "next/script";
import React, {useEffect, useState} from "react";
import {useToast} from "@/components/use-toast";

type EmbedFormProps = {
    id: string
};


const EmbedForm: React.FC<EmbedFormProps> = ({id}) => {
    const {toast} = useToast()
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://tally.so/widgets/embed.js'; // Replace with your script URL
        script.id = 'tally-js'
        // script.async = true; // Optional for asynchronous loading
        script.addEventListener("load", () => {
            // @ts-ignore*/}
            Tally.loadEmbeds()
        })
        script.addEventListener("error", (event) => {
            toast({
                className: "bg-darker",
                variant: "destructive",
                title: "Uh oh! Something went wrong.",
                description: "Fail to fetch form. please try again later",
            })
        })
        document.body.appendChild(script);
    }, []);

    return (
        <div className="w-full lg:w-4/5 lg:max-w-[1103px] px-9 relative">
            <iframe
                data-tally-src={`https://tally.so/embed/${id}?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1`}
                // @ts-ignore
                loading="lazy" width="100%" height="958" frameBorder="0" marginHeight="0" marginWidth="0"
                title="Request a session" onError={() => {
                toast({
                    className: "bg-darker",
                    variant: "destructive",
                    title: "Uh oh! Something went wrong.",
                    description: "Fail to fetch form. please try again later",
                })
            }}></iframe>
            {/*<Script*/}
            {/*    id="tally-js"*/}
            {/*    src="https://tally.so/widgets/embed.js"*/}
            {/*    onLoad={() => {*/}
            {/*        // @ts-ignore*/}
            {/*        Tally.loadEmbeds();*/}
            {/*        console.log('loadinggggg')*/}
            {/*    }}*/}
            {/*    strategy="afterInteractive"*/}
            {/*    onError={() => {*/}
            {/*        toast({*/}
            {/*            className: "bg-darker",*/}
            {/*            variant: "destructive",*/}
            {/*            title: "Uh oh! Something went wrong.",*/}
            {/*            description: "Fail to fetch form. please try again later",*/}
            {/*        })*/}
            {/*    }}*/}
            {/*/>*/}
            <div
                className="absolute right-9 bottom-[15px] min-[550px]:w-[190px] w-[50px] h-[45px] z-50 bg-blur-100">
            </div>
        </div>
    );
}

export default EmbedForm;